import React from 'react';
import type { H2HPlayer, H2HGlobalWinner } from '../../types/headToHead';

interface Props {
  a: H2HPlayer;
  b: H2HPlayer;
  globalWinner: H2HGlobalWinner;
}

export function H2HHeader({ a, b, globalWinner }: Props) {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 16 }}>
        <div style={{ textAlign: 'center', flex: 1 }}>
          {a.avatar ? <img src={a.avatar} alt="" style={{ width: 64, height: 64, borderRadius: 32 }} /> : <div style={avatarPlaceholder} />}
          <div style={{ color: '#fff', fontWeight: 700, marginTop: 6 }}>{a.name}</div>
        </div>
        <div style={{ color: '#fff', fontSize: 28, fontWeight: 900 }}>
          {globalWinner.score.a} - {globalWinner.score.b}
        </div>
        <div style={{ textAlign: 'center', flex: 1 }}>
          {b.avatar ? <img src={b.avatar} alt="" style={{ width: 64, height: 64, borderRadius: 32 }} /> : <div style={avatarPlaceholder} />}
          <div style={{ color: '#fff', fontWeight: 700, marginTop: 6 }}>{b.name}</div>
        </div>
      </div>
      <div style={{ color: '#FFD700', textAlign: 'center', fontWeight: 700, marginBottom: 12 }}>
        🏆 {globalWinner.label}
      </div>
    </div>
  );
}

const avatarPlaceholder: React.CSSProperties = { width: 64, height: 64, borderRadius: 32, background: '#444', margin: '0 auto' };
